module.exports = __webpack_public_path__ + "assets/loop-settings-active.a0086fdd.svg";